import { IUpdateReajusteUseCase } from "../../../presentation/useCases/update/update_reajuste_use_case";
import { Reajuste } from "../../models/reajuste";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * UpdateReajusteUseCase
 */

export class UpdateReajusteUseCase implements IUpdateReajusteUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async updateReajuste(form: Reajuste): Promise<void> {
    await this.repository.updateReajuste(form);
  }
}
